import { useCallback, useMemo } from 'react';
import { postMessageToParent } from '../post-message/postMessageToParent';
import { SCREEN_CAPTURE_REQUEST } from '../constants/PostMessageTypes';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGScreenCapture from 'visitor-ui-component-library-icons/icons/SVGScreenCapture';
import I18n from 'I18n';
import { MessageEditorTooltip } from '../message-editor/components/MessageEditorTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export function ScreenCaptureButton({
  mobile,
  disabled,
  hasConversationStarted
}) {
  const supportsScreenCapture = useMemo(() => {
    return navigator.mediaDevices && typeof navigator.mediaDevices.getDisplayMedia === 'function' && !mobile;
  }, [mobile]);
  const captureScreenshot = useCallback(() => {
    postMessageToParent(SCREEN_CAPTURE_REQUEST);
  }, []);
  if (!supportsScreenCapture) {
    return null;
  }
  const tooltipContent = hasConversationStarted ? I18n.text('conversations-visitor-experience-components.screenCapture') : I18n.text('conversations-visitor-experience-components.screenshotDisabledTooltip');
  return /*#__PURE__*/_jsx(MessageEditorTooltip, {
    content: tooltipContent,
    placement: "top center",
    children: /*#__PURE__*/_jsx(VizExIconButton, {
      disabled: disabled,
      onClick: captureScreenshot,
      use: "default-on-background",
      shape: "circle",
      "aria-label": I18n.text('conversations-visitor-experience-components.screenCapture'),
      children: /*#__PURE__*/_jsx(VizExIcon, {
        icon: /*#__PURE__*/_jsx(SVGScreenCapture, {}),
        size: "18px"
      })
    })
  });
}
ScreenCaptureButton.displayName = 'ScreenCaptureButton';